module.exports = "/images/scan-qr.png?159a69853970098256ee14a0a32e7436";